export default __webpack_public_path__ + "static/media/ascend-background-desktop.8d9cc356.png";